/**
 * @Relay no-runtime
 */
/**
 * @graphql cc
 */
import graphql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';
import { isNotFoundError } from '@confluence/error-boundary/entry-points/isNotFoundError.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import type { useCompanyHubPremiumGateCompanyHubPremiumGateQuery as useCompanyHubPremiumGateCompanyHubPremiumGateQuery$data } from './__types__/useCompanyHubPremiumGateCompanyHubPremiumGateQuery.ts';

export const useCompanyHubPremiumGate = ({ skip = false } = {}) => {
	const { edition } = useSessionData();

	const shouldSkip = skip || edition === ConfluenceEdition.PREMIUM;
	const { data, error } = useQuery<useCompanyHubPremiumGateCompanyHubPremiumGateQuery$data>(
		graphql`
			query useCompanyHubPremiumGateCompanyHubPremiumGateQuery {
				entitlements {
					companyHub {
						isEntitled
					}
				}
			}
		`,
		{
			skip: shouldSkip,
		},
	);

	if (error) {
		if (!(isUnauthorizedError(error) || isNotFoundError(error))) {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.PERFORMANCE_INSIGHTS,
			});
		}
		markErrorAsHandled(error);
	}

	return !shouldSkip && !data?.entitlements.companyHub.isEntitled;
};
